export const SYSTEM_COLUMN_SLUGS = new Set(["backlog", "in_progress", "done"]);

export function isSystemColumn(column) {
  return SYSTEM_COLUMN_SLUGS.has(column?.slug);
}

export function defaultMoveTargetId(columns, deletingId) {
  const others = columns.filter((col) => col.id !== deletingId);
  const backlog = others.find((col) => col.slug === "backlog");
  return (backlog || others[0])?.id ?? null;
}

export const COLLAPSED_COLUMNS_PREFIX = "vita-tasks-collapsed-columns";

export function collapsedStorageKey(boardId) {
  return `${COLLAPSED_COLUMNS_PREFIX}:${boardId}`;
}

export function readCollapsedColumnIds(storage, boardId) {
  if (!storage || boardId == null) return [];
  try {
    const parsed = JSON.parse(storage.getItem(collapsedStorageKey(boardId)));
    if (!Array.isArray(parsed)) return [];
    return [...new Set(parsed.map(Number).filter(Number.isInteger))];
  } catch {
    return [];
  }
}

export function writeCollapsedColumnIds(storage, boardId, ids) {
  if (!storage || boardId == null) return;
  storage.setItem(
    collapsedStorageKey(boardId),
    JSON.stringify([...new Set(ids.map(Number).filter(Number.isInteger))])
  );
}

export function toggleCollapsedColumnId(ids, columnId) {
  const next = new Set(ids);
  if (next.has(columnId)) next.delete(columnId);
  else next.add(columnId);
  return [...next];
}

export function computeColumnReorder(columns, activeId, overId) {
  if (activeId == null || overId == null || activeId === overId) return null;
  const fromIndex = columns.findIndex((col) => col.id === activeId);
  const toIndex = columns.findIndex((col) => col.id === overId);
  if (fromIndex < 0 || toIndex < 0) return null;
  return { columnId: activeId, position: toIndex };
}
